<template>
	<div>
		<app-overlay-loader v-if="preloader" />
		<form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form" :data-url="selectedUrl
				? `transaction/course-history/${inputs.id}`
				: `transaction/course-history`
			">
			<div class="form-group row align-items-center">
				<label for="inputs_reference_id" class="col-sm-3 mb-0">
					Reference ID
				</label>
				<app-input id="inputs_reference_id" class="col-sm-9" type="text" v-model="inputs.reference_id"
					placeholder="Reference ID" read-only />
			</div>
			<div class="form-group row align-items-center">
				<label for="inputs_course_id" class="col-sm-3 mb-0">
					Class Name
				</label>
				<app-input id="inputs_course_id" type="advance-search-select" :loaded-per-time="10"
					v-model="input_course_id" @input="setCourseIdValue" fetch-url="transaction/course" class="col-sm-9"
					placeholder="Class Name" list-value-field="course_name" required />
			</div>
			<div class="form-group row align-items-center">
				<label for="inputs_course_type_id" class="col-sm-3 mb-0">
					Class Type
				</label>
				<app-input id="inputs_course_type_id" type="advance-search-select" :loaded-per-time="10"
					v-model="input_course_type_id" @input="setCourseTypeIdValue" fetch-url="master/course-type"
					class="col-sm-9" placeholder="Class Type" list-value-field="course_type_desc" required />
			</div>
			<div class="form-group row align-items-center">
				<label for="inputs_center_id" class="col-sm-3 mb-0">
					CLC Centre
				</label>
				<app-input id="inputs_center_id" type="advance-search-select" :loaded-per-time="10"
					v-model="input_center_id" @input="setCenterIdValue" fetch-url="master/center" class="col-sm-9"
					placeholder="CLC Centre" list-value-field="name" required />
			</div>
			<div class="form-group row align-items-center">
				<label for="inputs_sub_status" class="col-sm-3 mb-0">
					Sub Status
				</label>
				<app-input id="inputs_sub_status" class="col-sm-9" type="advance-search-select" :loaded-per-time="10"
					v-model="input_sub_status" @input="setSubStatusValue"
					:fetch-url="`/master/lead-status?lead_status_id=3&per_page=50`" :placeholder="'Sub Status'"
					list-value-field="status" />
			</div>
			<div class="form-group row align-items-center">
				<label for="inputs_cc_id" class="col-sm-3 mb-0"> CC </label>
				<app-input id="inputs_cc_id" type="advance-search-select" :loaded-per-time="10" v-model="input_cc_id"
					@input="setCcIdValue" fetch-url="user-list" class="col-sm-9" placeholder="CC"
					list-value-field="full_name" required />
			</div>
			<div class="form-group row align-items-center">
				<label for="inputs_sc_id" class="col-sm-3 mb-0"> SC </label>
				<app-input id="inputs_sc_id" type="advance-search-select" :loaded-per-time="10" v-model="input_sc_id"
					@input="setScIdValue" fetch-url="user-list" class="col-sm-9" placeholder="SC"
					list-value-field="full_name" required />
			</div>
			<div class="form-group row align-items-center">
				<label for="inputs_main_teacher_id" class="col-sm-3 mb-0">
					Main Teacher
				</label>
				<app-input id="inputs_main_teacher_id" type="advance-search-select" :loaded-per-time="10"
					v-model="input_main_teacher_id" @input="setMainTeacherIdValue" fetch-url="user-list"
					class="col-sm-9" placeholder="Main Teacher" list-value-field="full_name" required />
			</div>
			<div class="form-group row align-items-center">
				<label for="inputs_co_teacher_id" class="col-sm-3 mb-0">
					CO Teacher
				</label>
				<app-input id="inputs_co_teacher_id" type="advance-search-select" :loaded-per-time="10"
					v-model="input_co_teacher_id" @input="setCoTeacherIdValue" fetch-url="user-list" class="col-sm-9"
					placeholder="CO Teacher" list-value-field="full_name" required />
			</div>
			<div class="form-group row align-items-center">
				<label for="inputs_start_week" class="col-sm-3 mb-0">
					Start Week
				</label>
				<app-input id="inputs_start_week" class="col-sm-9" type="text" v-model="inputs.start_week"
					placeholder="Start Week" />
			</div>
			<div class="form-group row align-items-center">
				<label for="inputs_end_week" class="col-sm-3 mb-0">
					End Week
				</label>
				<app-input id="inputs_end_week" class="col-sm-9" type="text" v-model="inputs.end_week"
					placeholder="End Week" />
			</div>
			<!-- <div class="form-group row align-items-center">
					<label for="inputs_attendance" class="col-sm-3 mb-0">
						Attendance
					</label>
					<app-input
						id="inputs_attendance"
						class="col-sm-9"
						type="text"
						v-model="inputs.attendance"
						placeholder="Attendance"
						:required="true"
					/>
				</div> -->
		</form>
	</div>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";

export default {
	name: "ClassTableFormWithoutModal",
	mixins: [FormMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
		rowData: {
			type: Object,
			default: () => {
				return {
					id: "",
					clc_id_number: "",
				};
			},
		},
        onAfterSubmit: {
            type: Function,
            default: (status, res) => console.log('onAfterSubmit = ' + status + ':', res),
        },
	},
	data() {
		return {
			preloader: false,
			inputs: {
				clc_id_number: this.rowData?.clc_id_number ?? null,
			},
			subStatusLists: [],
			input_course_id: this.value
				? this.value.course
					? {
						id: this.value.course.id || 0,
						course_name: this.value.course.course_name || "",
						is_active: this.value.course.is_active,
					}
					: {
						id: this.value.course?.id || 0,
						course_name: this.value.course?.course_name || "",
						is_active: this.value.course?.is_active,
					}
				: {
					id: this.value.course.id || 0,
					course_name: this.value.course.course_name || "",
					is_active: this.value.course.is_active,
				},
			input_course_type_id: this.value
				? this.value.course_type
					? {
						id: this.value.course_type.id || 0,
						course_type_name:
							this.value.course_type.course_type_name || "",
						is_active: this.value.course_type.is_active,
					}
					: {
						id: this.value.course_type?.id || 0,
						course_type_name:
							this.value.course_type?.course_type_name || "",
						is_active: this.value.course_type?.is_active,
					}
				: {
					id: this.value.course_type.id || 0,
					course_type_name:
						this.value.course_type.course_type_name || "",
					is_active: this.value.course_type.is_active,
				},
			input_center_id: this.value
				? this.value.center
					? {
						id: this.value.center.id || 0,
						name: this.value.center.name || "",
						is_active: this.value.center.is_active,
					}
					: {
						id: this.value.center?.id || 0,
						name: this.value.center?.name || "",
						is_active: this.value.center?.is_active,
					}
				: {
					id: this.value.center.id || 0,
					name: this.value.center.name || "",
					is_active: this.value.center.is_active,
				},
			input_cc_id: this.value
				? this.value.cc
					? {
						id: this.value.cc.id || 0,
						full_name: this.value.cc.full_name || "",
						is_active: this.value.cc.is_active,
					}
					: {
						id: this.value.cc?.id || 0,
						full_name: this.value.cc?.full_name || "",
						is_active: this.value.cc?.is_active,
					}
				: {
					id: this.value.cc.id || 0,
					full_name: this.value.cc.full_name || "",
					is_active: this.value.cc.is_active,
				},
			input_sc_id: this.value
				? this.value.sc
					? {
						id: this.value.sc.id || 0,
						full_name: this.value.sc.full_name || "",
						is_active: this.value.sc.is_active,
					}
					: {
						id: this.value.sc?.id || 0,
						full_name: this.value.sc?.full_name || "",
						is_active: this.value.sc?.is_active,
					}
				: {
					id: this.value.sc.id || 0,
					full_name: this.value.sc.full_name || "",
					is_active: this.value.sc.is_active,
				},
			input_main_teacher_id: this.value
				? this.value.main_teacher
					? {
						id: this.value.main_teacher.id || 0,
						full_name: this.value.main_teacher.full_name || "",
						is_active: this.value.main_teacher.is_active,
					}
					: {
						id: this.value.main_teacher?.id || 0,
						full_name: this.value.main_teacher?.full_name || "",
						is_active: this.value.main_teacher?.is_active,
					}
				: {
					id: this.value.main_teacher.id || 0,
					full_name: this.value.main_teacher.full_name || "",
					is_active: this.value.main_teacher.is_active,
				},
			input_co_teacher_id: this.value
				? this.value.co_teacher
					? {
						id: this.value.co_teacher.id || 0,
						full_name: this.value.co_teacher.full_name || "",
						is_active: this.value.co_teacher.is_active,
					}
					: {
						id: this.value.co_teacher?.id || 0,
						full_name: this.value.co_teacher?.full_name || "",
						is_active: this.value.co_teacher?.is_active,
					}
				: {
					id: this.value.co_teacher.id || 0,
					full_name: this.value.co_teacher.full_name || "",
					is_active: this.value.co_teacher.is_active,
				},
			input_sub_status: this.value
				? this.value.sub_status
					? {
						id: this.value.sub_status.id || 0,
						status: this.value.sub_status.status || "",
					}
					: {
						id: this.value.sub_status?.id || 0,
						status: this.value.sub_status?.status || "",
					}
				: {
					id: this.value.sub_status.id || 0,
					status: this.value.sub_status.status || "",
				},
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				let [subStatusResponse] = await Promise.all([
					axios.get(
						"/master/lead-status?lead_status_id=3&per_page=100"
					),
				]);

				subStatusResponse.data.data.forEach((item) => {
					this.subStatusLists.push({
						id: item.id,
						value: item.status,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
            this.onAfterSubmit?.(true, response);
		},
		afterError(response) {
			this.$toastr.s(response.data.message);
            this.onAfterSubmit?.(false, response);
		},
		afterSuccessFromGetEditData(response) {
			this.inputs.id = response.data.id;
			this.input_sub_status = {
				id: this.inputs.sub_status_id?.id || 0,
				status: this.inputs.sub_status_id?.status || "",
			};
			this.inputs.reference_id =
				response.data.payment_received_id?.invoice_fk?.reference_id;
			this.input_course_id = {
				id: response.data.course_id?.id,
				course_name: response.data.course_id?.course_name,
			};
			this.inputs.course_id = response.data.course_id?.id;
			let course_type = response.data.course_id?.course_type_id;
			if (course_type == 1) {
				course_type = "App";
			} else if (course_type == 2) {
				course_type = "Hybrid";
			} else if (course_type == 3) {
				course_type = "Online";
			} else if (course_type == 4) {
				course_type = "Offline";
			}
			this.input_course_type_id = {
				id: response.data.course_id?.course_type_id,
				course_type_name: course_type,
			};
			this.inputs.course_type_id =
				response.data.course_id?.course_type_id;
			this.input_center_id = {
				id: response.data.payment_received_id?.invoice_fk?.center_id
					?.id,
				name: response.data.payment_received_id?.invoice_fk?.center_id
					?.name,
			};
			this.inputs.center_id =
				response.data.payment_received_id?.invoice_fk?.center_id?.id;
			if (response.data.sub_status) {
				this.inputs.sub_status = response.data.sub_status;
			}
			this.input_cc_id = {
				id: response.data.cc_id?.id,
				full_name: response.data.cc_id?.full_name,
			};
			this.inputs.cc_id = response.data.cc_id?.id;
			this.input_sc_id = {
				id: response.data.course_group_id?.student_care_id?.id,
				full_name:
					response.data.course_group_id?.student_care_id?.full_name,
			};
			this.inputs.sc_id =
				response.data.course_group_id?.student_care_id?.id;
			this.input_main_teacher_id = {
				id: response.data.course_group_id?.teach_id?.id,
				full_name: response.data.course_group_id?.teach_id?.full_name,
			};
			this.inputs.main_teacher_id =
				response.data.course_group_id?.teach_id?.id;
			this.input_co_teacher_id = {
				id: response.data.course_group_id?.teach_assistant_id?.id,
				full_name:
					response.data.course_group_id?.teach_assistant_id
						?.full_name,
			};
			this.inputs.co_teacher_id =
				response.data.course_group_id?.teach_assistant_id?.id;
			this.inputs.start_week = response.data.date_start_clc;
			this.inputs.end_week = response.data.date_end_clc;
			this.preloader = false;
		},

		setCourseIdValue(data) {
			this.inputs.course_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.course_id = data.id;
			}
		},
		setCourseTypeIdValue(data) {
			this.inputs.course_type_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.course_type_id = data.id;
			}
		},
		setCenterIdValue(data) {
			this.inputs.center_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.center_id = data.id;
			}
		},
		setCcIdValue(data) {
			this.inputs.cc_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.cc_id = data.id;
			}
		},
		setScIdValue(data) {
			this.inputs.sc_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.sc_id = data.id;
			}
		},
		setMainTeacherIdValue(data) {
			this.inputs.main_teacher_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.main_teacher_id = data.id;
			}
		},
		setCoTeacherIdValue(data) {
			this.inputs.co_teacher_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.co_teacher_id = data.id;
			}
		},
		setSubStatusValue(data) {
			this.inputs.sub_status = this.inputs.sub_status;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.sub_status = data.id;
			}
		},
	},
};
</script>
